//11、旋转锁孔
import makerjs from "makerjs";
// inputParam,model,myHolesNum,outParam,fixedParam
// (D,X,Y,area,plate,markers,myHolesNum,glassW,glassH,markShift,markShiftTwo,markShiftThree,markShiftFour,markHolesOneD)
function RotatLockHole(inputParam, model, myHolesNum, outParam, fixedParam, zoom, θCut, rCut,cutLine,cutFilletRadius){
var D=inputParam.D,W=inputParam.W,H=inputParam.H,X=inputParam.X,Y=inputParam.Y,area=inputParam.area,myZoom=zoom*1, myθCut = θCut, myrCut = rCut,
plate = model.plate, cutPlate = model.cutPlate, markers = model.markers,
glassW=outParam.glassW,glassH=outParam.glassH,
   markShift=fixedParam.markShift*1,markShiftTwo=fixedParam.markShiftTwo*1,
   markShiftThree=fixedParam.markShiftThree*1,markShiftFour=fixedParam.markShiftFour*1,markHolesOneD=fixedParam.markHolesOneD*1,
 
   d = D*1*myZoom,
      w= W*1*myZoom,
      h= H*1*myZoom,
        x0 = X*1*myZoom,
        y0 = Y*1*myZoom;
        if(plate.models===undefined||plate.models===""){
            console.log("1111111111111111");
            plate.models={};
           }        
        if(cutPlate.models===undefined||cutPlate.models===""){
         console.log("22222222222");
                        //cutPlate.models={};
                        cutPlate.models={};
          }
       if(markers.models===undefined||markers.models===""){            
                        console.log("333333333333");
                        markers.models={};
         }
        /*
        d = D*1,
           w= W*1,
           h= H*1,
             x0 = X*1,
             y0 = Y*1;
             */
        if(d!==0){
         var TxtD="∮"+D;
        }
        if(h!==0){
         var TxtH=H;
        }
        if(w!==0){
         var TxtW=W;
        }
        if(x0!==0){          
        var TxtX=X;
        }
        if(y0!==0){          
         var TxtY=Y;
        }
  //在A区域 计算孔的位置       
  var xa=x0,ya=glassH * 1-y0,
  //B区域//只有Y标注没有X标注 
  xb=glassW * 1/2,yb=glassH * 1-y0,
  //C区域
  xc=glassW * 1-x0,yc=glassH * 1-y0,
  //D区域
  //只有X标注没有Y标注 
  xd=x0,yd=glassH * 1/2,
  //E区域
  //只有X标注没有Y标注 
  xe=glassW * 1/2,ye=glassH * 1/2,
  //F区域
  //只有X标注没有Y标注 
  xf=glassW * 1-x0,yf=glassH * 1/2,
  //在G区域 计算孔的位置
  xg=x0,yg=y0,
  //在H区域 计算孔的位置
  //只标注Y
  xh=glassW*1/2,yh=y0,
  //在I区域 计算孔的位置
  xi=glassW*1-x0,yi=y0;
  if(glassW*1>glassH * 1){
      console.log("长边在X轴￥￥￥￥￥");
      if(area==1){
        //画孔 A位置孔
            //标记旋转锁孔 A位置孔左上
            var myRlhHolesALeftup= new makerjs.models.Holes(d/2, [[xa, ya]]);
            //标记孔
            var myRlhHolesMarkALeftup = new makerjs.models.Square(0); //孔的原点       
            myRlhHolesMarkALeftup.origin = [xa, ya];      
            var myRlhHolesXMarkALeftup = new makerjs.models.Square(0);      
            myRlhHolesXMarkALeftup.origin =[xa, ya];      
            var myRlhHolesYMarkALeftup = new makerjs.models.Square(0);      
            myRlhHolesYMarkALeftup.origin = [xa, ya];  
      
      /*****************************************************************************/ 
      makerjs.model.addPath(myRlhHolesMarkALeftup, new makerjs.paths.Line([-x0,y0], [-x0, y0+markShiftTwo]));//Y轴加长标线
      makerjs.model.addPath(myRlhHolesMarkALeftup, new makerjs.paths.Line([0,0], [-x0-markShiftThree, 0]));//从孔圆心出发X方向横向标线
      makerjs.model.addPath(myRlhHolesMarkALeftup, new makerjs.paths.Line([-x0,y0], [-x0-markShiftThree, y0]));//X轴加长标线
      makerjs.model.addPath(myRlhHolesMarkALeftup, new makerjs.paths.Line([0,0], [0, y0+markShiftTwo]));//从孔圆心出发Y方向竖向标线
      /*****************************************************************************/ 
      makerjs.model.addPath(myRlhHolesMarkALeftup, new makerjs.paths.Line([0,0], [d, -d]));//直径标线
      makerjs.model.addCaption(myRlhHolesMarkALeftup, TxtD, [0,0], [d+markHolesOneD, -d-markHolesOneD]);//直径文字标注
      /*****************************************************************************/   
      makerjs.model.addPath(myRlhHolesXMarkALeftup, new makerjs.paths.Line([0,y0+markShift], [-x0, y0+markShift]));//X短标线
      makerjs.model.addCaption(myRlhHolesXMarkALeftup, TxtX, [-x0,y0+markShiftTwo], [0, y0+markShiftTwo]);//X文字标注
      /*****************************************************************************/     
      makerjs.model.addPath(myRlhHolesYMarkALeftup, new makerjs.paths.Line([-x0-markShiftTwo,0], [-x0-markShiftTwo, y0]));//Y短标线
      makerjs.model.addCaption(myRlhHolesYMarkALeftup, TxtY, [-x0-markShiftThree,0], [-x0-markShiftThree, y0]);//Y文字标注
      /*****************************************************************************/ 
      /*****************************************************************************/ 
      //画孔 A位置孔
            //标记旋转锁孔 A位置孔右上
            var myRlhHolesARightup= new makerjs.models.Holes(d/2, [[xa+w, ya]]);
            var myRlhHolesMarkARightup = new makerjs.models.Square(0); //孔的原点       
            myRlhHolesMarkARightup.origin = [xa+w, ya];      
            var myRlhHolesXMarkARightup = new makerjs.models.Square(0);      
            myRlhHolesXMarkARightup.origin =[xa+w, ya]; 
      /*****************************************************************************/ 
      makerjs.model.addPath(myRlhHolesMarkARightup, new makerjs.paths.Line([0,0], [-w, 0]));//从孔圆心出发X方向横向标线
      makerjs.model.addPath(myRlhHolesMarkARightup, new makerjs.paths.Line([0,0], [0, y0+markShiftTwo]));//从孔圆心出发Y方向竖向标线
      /*****************************************************************************/ 
      makerjs.model.addPath(myRlhHolesMarkARightup, new makerjs.paths.Line([0,0], [d, -d]));//直径标线
      makerjs.model.addCaption(myRlhHolesMarkARightup, TxtD, [0,0], [d+markHolesOneD, -d-markHolesOneD]);//直径文字标注
      /*****************************************************************************/   
      makerjs.model.addPath(myRlhHolesXMarkARightup, new makerjs.paths.Line([0,y0+markShift], [-w, y0+markShift]));//X短标线
      makerjs.model.addCaption(myRlhHolesXMarkARightup, TxtW, [-w,y0+markShiftTwo], [0, y0+markShiftTwo]);//X文字标注
      /*****************************************************************************/  
      /*****************************************************************************/ 
       //标记旋转锁孔 A位置孔左下
       var myRlhHolesALeftdn= new makerjs.models.Holes(d/2, [[xa, ya-h]]);
            var myRlhHolesMarkALeftdn = new makerjs.models.Square(0); //孔的原点       
            myRlhHolesMarkALeftdn.origin = [xa, ya-h];   
            var myRlhHolesYMarkALeftdn = new makerjs.models.Square(0);      
            myRlhHolesYMarkALeftdn.origin = [xa, ya-h]; 
      /*****************************************************************************/ 
      makerjs.model.addPath(myRlhHolesMarkALeftdn, new makerjs.paths.Line([0,0], [-x0-markShiftThree, 0]));//从孔圆心出发X方向横向标线
      makerjs.model.addPath(myRlhHolesMarkALeftdn, new makerjs.paths.Line([0,0], [0, h+markShiftTwo]));//从孔圆心出发Y方向竖向标线
      /*****************************************************************************/ 
      makerjs.model.addPath(myRlhHolesMarkALeftdn, new makerjs.paths.Line([0,0], [d, -d]));//直径标线
      makerjs.model.addCaption(myRlhHolesMarkALeftdn, TxtD, [0,0], [d+markHolesOneD, -d-markHolesOneD]);//直径文字标注
      /*****************************************************************************/  
      /*****************************************************************************/     
      makerjs.model.addPath(myRlhHolesYMarkALeftdn, new makerjs.paths.Line([-x0-markShiftTwo,0], [-x0-markShiftTwo, h]));//Y短标线
      makerjs.model.addCaption(myRlhHolesYMarkALeftdn, TxtH, [-x0-markShiftThree,0], [-x0-markShiftThree, h]);//Y文字标注
      /*****************************************************************************/ 
      plate.models["TypeHoles_RotatLockHole_ALeftup"+myHolesNum]=myRlhHolesALeftup;
      cutPlate.models["TypeHoles_RotatLockHole_ALeftup"+myHolesNum]=myRlhHolesALeftup;
      markers.models["TypeHoles_RotatLockHole_ALeftup"+myHolesNum]=myRlhHolesALeftup;
      markers.models["TypeHoles_RotatLockHole_MarkALeftup"+myHolesNum]=myRlhHolesMarkALeftup;
      markers.models["TypeHoles_RotatLockHole_XMarkALeftup"+myHolesNum]=myRlhHolesXMarkALeftup;
      markers.models["TypeHoles_RotatLockHole_YMarkALeftup"+myHolesNum]=myRlhHolesYMarkALeftup;
      /*****************************************************************************/
      plate.models["TypeHoles_RotatLockHole_ALeftdn"+myHolesNum]=myRlhHolesALeftdn;
      cutPlate.models["TypeHoles_RotatLockHole_ALeftdn"+myHolesNum]=myRlhHolesALeftdn;
      markers.models["TypeHoles_RotatLockHole_ALeftdn"+myHolesNum]=myRlhHolesALeftdn;
      markers.models["TypeHoles_RotatLockHole_MarkALeftdn"+myHolesNum]=myRlhHolesMarkALeftdn;
      markers.models["TypeHoles_RotatLockHole_YMarkALeftdn"+myHolesNum]=myRlhHolesYMarkALeftdn;
      /*****************************************************************************/ 
      plate.models["TypeHoles_RotatLockHole_ARightup"+myHolesNum]=myRlhHolesARightup;
      cutPlate.models["TypeHoles_RotatLockHole_ARightup"+myHolesNum]=myRlhHolesARightup;
      markers.models["TypeHoles_RotatLockHole_ARightup"+myHolesNum]=myRlhHolesARightup;
      markers.models["TypeHoles_RotatLockHole_MarkARightup"+myHolesNum]=myRlhHolesMarkARightup;
      markers.models["TypeHoles_RotatLockHole_XMarkARightup"+myHolesNum]=myRlhHolesXMarkARightup;
      /*****************************************************************************/ 
      
      } else if(area==2){
       //画孔 B位置孔
            //标记旋转锁孔 B位置孔左上
            var myRlhHolesBLeftup= new makerjs.models.Holes(d/2, [[xb-w/2, yb]]);
            //标记孔
            var myRlhHolesMarkBLeftup = new makerjs.models.Square(0); //孔的原点       
            myRlhHolesMarkBLeftup.origin = [xb-w/2, yb];      
            var myRlhHolesXMarkBLeftup = new makerjs.models.Square(0);      
            myRlhHolesXMarkBLeftup.origin =[xb-w/2, yb];      
            var myRlhHolesYMarkBLeftup = new makerjs.models.Square(0);      
            myRlhHolesYMarkBLeftup.origin = [xb-w/2, yb];  
      
      /*****************************************************************************/ 
      makerjs.model.addPath(myRlhHolesMarkBLeftup, new makerjs.paths.Line([xb,0], [xb+w/2+markShiftFour, 0]));//Y轴加长标线
      makerjs.model.addPath(myRlhHolesMarkBLeftup, new makerjs.paths.Line([0,y0], [xb+w/2+markShiftFour, y0]));//X轴加长标线
      makerjs.model.addPath(myRlhHolesMarkBLeftup, new makerjs.paths.Line([0,0], [0, y0]));//从孔圆心出发Y方向竖向标线
      /*****************************************************************************/ 
      makerjs.model.addPath(myRlhHolesMarkBLeftup, new makerjs.paths.Line([0,0], [d, -d]));//直径标线
      makerjs.model.addCaption(myRlhHolesMarkBLeftup, TxtD, [0,0], [d+markHolesOneD, -d-markHolesOneD]);//直径文字标注
      /*****************************************************************************/    
      makerjs.model.addPath(myRlhHolesYMarkBLeftup, new makerjs.paths.Line([xb+w/2+markShift,0], [xb+w/2+markShift, y0]));//Y短标线
      makerjs.model.addCaption(myRlhHolesYMarkBLeftup, TxtY, [xb+w/2+markShiftThree,0], [xb+w/2+markShiftThree, y0]);//Y文字标注
      /*****************************************************************************/ 
      //画孔 B位置孔
            //标记旋转锁孔 B位置孔右上
            var myRlhHolesBRightup= new makerjs.models.Holes(d/2, [[xb+w/2, yb]]);
            var myRlhHolesMarkBRightup = new makerjs.models.Square(0); //孔的原点       
            myRlhHolesMarkBRightup.origin = [xb+w/2, yb];      
            var myRlhHolesXMarkBRightup = new makerjs.models.Square(0);      
            myRlhHolesXMarkBRightup.origin =[xb+w/2, yb]; 
      /*****************************************************************************/ 
      makerjs.model.addPath(myRlhHolesMarkBRightup, new makerjs.paths.Line([0,0], [0, y0]));//从孔圆心出发X方向横向标线
      /*****************************************************************************/   
      makerjs.model.addPath(myRlhHolesXMarkBRightup, new makerjs.paths.Line([0,0], [-w, 0]));//X短标线
      makerjs.model.addCaption(myRlhHolesXMarkBRightup, TxtW, [-w,0+markShift], [0, 0+markShift]);//X文字标注
      /*****************************************************************************/ 
       //标记旋转锁孔 B位置孔左下
       var myRlhHolesBLeftdn= new makerjs.models.Holes(d/2, [[xb-w/2, yb-h]]);
            var myRlhHolesMarkBLeftdn = new makerjs.models.Square(0); //孔的原点       
            myRlhHolesMarkBLeftdn.origin = [xb-w/2, yb-h];   
            var myRlhHolesYMarkBLeftdn = new makerjs.models.Square(0);      
            myRlhHolesYMarkBLeftdn.origin = [xb-w/2, yb-h]; 
      /*****************************************************************************/ 
      makerjs.model.addPath(myRlhHolesMarkBLeftdn, new makerjs.paths.Line([0,0], [xb+w/2+markShiftFour, 0]));//从孔圆心出发X方向横向标线
      makerjs.model.addPath(myRlhHolesMarkBLeftdn, new makerjs.paths.Line([0,0], [0, h]));//从孔圆心出发Y方向竖向标线
      makerjs.model.addPath(myRlhHolesYMarkBLeftdn, new makerjs.paths.Line([xb+w/2+markShift,0], [xb+w/2+markShift, h]));//Y短标线
      makerjs.model.addCaption(myRlhHolesYMarkBLeftdn, TxtH, [xb+w/2+markShiftThree,0], [xb+w/2+markShiftThree, h]);//Y文字标注
      /*****************************************************************************/ 
      plate.models["TypeHoles_RotatLockHole_BLeftup"+myHolesNum]=myRlhHolesBLeftup;
      cutPlate.models["TypeHoles_RotatLockHole_BLeftup"+myHolesNum]=myRlhHolesBLeftup;
      markers.models["TypeHoles_RotatLockHole_BLeftup"+myHolesNum]=myRlhHolesBLeftup;
      markers.models["TypeHoles_RotatLockHole_MarkBLeftup"+myHolesNum]=myRlhHolesMarkBLeftup;
      markers.models["TypeHoles_RotatLockHole_XMarkBLeftup"+myHolesNum]=myRlhHolesXMarkBLeftup;
      markers.models["TypeHoles_RotatLockHole_YMarkBLeftup"+myHolesNum]=myRlhHolesYMarkBLeftup;
      /*****************************************************************************/
      plate.models["TypeHoles_RotatLockHole_BLeftdn"+myHolesNum]=myRlhHolesBLeftdn;
      cutPlate.models["TypeHoles_RotatLockHole_BLeftdn"+myHolesNum]=myRlhHolesBLeftdn;
      markers.models["TypeHoles_RotatLockHole_BLeftdn"+myHolesNum]=myRlhHolesBLeftdn;
      markers.models["TypeHoles_RotatLockHole_MarkBLeftdn"+myHolesNum]=myRlhHolesMarkBLeftdn;
      markers.models["TypeHoles_RotatLockHole_YMarkBLeftdn"+myHolesNum]=myRlhHolesYMarkBLeftdn;
      /*****************************************************************************/ 
      plate.models["TypeHoles_RotatLockHole_BRightup"+myHolesNum]=myRlhHolesBRightup;
      cutPlate.models["TypeHoles_RotatLockHole_BRightup"+myHolesNum]=myRlhHolesBRightup;
      markers.models["TypeHoles_RotatLockHole_BRightup"+myHolesNum]=myRlhHolesBRightup;
      markers.models["TypeHoles_RotatLockHole_MarkBRightup"+myHolesNum]=myRlhHolesMarkBRightup;
      markers.models["TypeHoles_RotatLockHole_XMarkBRightup"+myHolesNum]=myRlhHolesXMarkBRightup;
      /*****************************************************************************/ 
         
      } else if(area==7){
      //画孔 G位置孔
            //标记旋转锁孔 G位置孔右上
            var myRlhHolesGRightup= new makerjs.models.Holes(d/2, [[xg, yg]]);
            //标记孔
            var myRlhHolesMarkGRightup = new makerjs.models.Square(0); //孔的原点       
            myRlhHolesMarkGRightup.origin = [xg, yg];      
            var myRlhHolesXMarkGRightup = new makerjs.models.Square(0);      
            myRlhHolesXMarkGRightup.origin =[xg, yg];      
            var myRlhHolesYMarkGRightup = new makerjs.models.Square(0);      
            myRlhHolesYMarkGRightup.origin = [xg, yg];  
      /*****************************************************************************/ 
      makerjs.model.addPath(myRlhHolesMarkGRightup, new makerjs.paths.Line([-x0,-y0], [-x0, -y0-markShiftFour]));//Y轴加长标线
      makerjs.model.addPath(myRlhHolesMarkGRightup, new makerjs.paths.Line([0,0], [-x0-markShiftThree, 0]));//从孔圆心出发X方向横向标线
      makerjs.model.addPath(myRlhHolesMarkGRightup, new makerjs.paths.Line([-x0,-y0], [-x0-markShiftThree, -y0]));//X轴加长标线
      makerjs.model.addPath(myRlhHolesMarkGRightup, new makerjs.paths.Line([0,0], [0, -y0-markShiftFour]));//从孔圆心出发Y方向竖向标线
      /*****************************************************************************/ 
      makerjs.model.addPath(myRlhHolesMarkGRightup, new makerjs.paths.Line([0,0], [d, -d]));//直径标线
      makerjs.model.addCaption(myRlhHolesMarkGRightup, TxtD, [0,0], [d+markHolesOneD, -d-markHolesOneD]);//直径文字标注
      /*****************************************************************************/   
      makerjs.model.addPath(myRlhHolesXMarkGRightup, new makerjs.paths.Line([0,-y0-markShiftTwo], [-x0, -y0-markShiftTwo]));//X短标线
      makerjs.model.addCaption(myRlhHolesXMarkGRightup, TxtX, [-x0,-y0-markShiftFour], [0, -y0-markShiftFour]);//X文字标注
      /*****************************************************************************/     
      makerjs.model.addPath(myRlhHolesYMarkGRightup, new makerjs.paths.Line([-x0-markShiftTwo,0], [-x0-markShiftTwo, -y0]));//Y短标线
      makerjs.model.addCaption(myRlhHolesYMarkGRightup, TxtY, [-x0-markShiftFour, -y0], [-x0-markShiftFour,0]);//Y文字标注
      /*****************************************************************************/ 
      //画孔 G位置孔
            //标记旋转锁孔 G位置孔左上
            var myRlhHolesGLeftup= new makerjs.models.Holes(d/2, [[xg, yg+h]]);
            var myRlhHolesMarkGLeftup = new makerjs.models.Square(0); //孔的原点       
            myRlhHolesMarkGLeftup.origin = [xg, yg+h];      
            var myRlhHolesXMarkGLeftup = new makerjs.models.Square(0);      
            myRlhHolesXMarkGLeftup.origin =[xg, yg+h]; 
      /*****************************************************************************/ 
      makerjs.model.addPath(myRlhHolesMarkGLeftup, new makerjs.paths.Line([0,0], [0, -h]));//从孔圆心出发X方向横向标线
      makerjs.model.addPath(myRlhHolesMarkGLeftup, new makerjs.paths.Line([0,0], [-x0-markShiftFour, 0]));//从孔圆心出发Y方向竖向标线
      /*****************************************************************************/ 
      makerjs.model.addPath(myRlhHolesMarkGLeftup, new makerjs.paths.Line([0,0], [d, -d]));//直径标线
      makerjs.model.addCaption(myRlhHolesMarkGLeftup, TxtD, [0,0], [d+markHolesOneD, -d-markHolesOneD]);//直径文字标注
      /*****************************************************************************/   
      makerjs.model.addPath(myRlhHolesXMarkGLeftup, new makerjs.paths.Line([-x0-markShiftTwo,-h], [-x0-markShiftTwo,0]));//X短标线
      makerjs.model.addCaption(myRlhHolesXMarkGLeftup, TxtH,[-x0-markShiftFour,-h], [-x0-markShiftFour,0]);//X文字标注
      /*****************************************************************************/ 
       //标记旋转锁孔 G位置孔右下
       var myRlhHolesGRightdn= new makerjs.models.Holes(d/2, [[xg+w, yg]]);
            var myRlhHolesMarkGRightdn = new makerjs.models.Square(0); //孔的原点       
            myRlhHolesMarkGRightdn.origin = [xg+w, yg];   
            var myRlhHolesYMarkGRightdn = new makerjs.models.Square(0);      
            myRlhHolesYMarkGRightdn.origin = [xg+w, yg]; 
      /*****************************************************************************/ 
      makerjs.model.addPath(myRlhHolesMarkGRightdn, new makerjs.paths.Line([0,0], [0, -y0-markShiftThree]));//从孔圆心出发X方向横向标线
      makerjs.model.addPath(myRlhHolesMarkGRightdn, new makerjs.paths.Line([0,0], [-w-markShiftTwo,0]));//从孔圆心出发Y方向竖向标线
      /*****************************************************************************/ 
      makerjs.model.addPath(myRlhHolesMarkGRightdn, new makerjs.paths.Line([0,0], [d, -d]));//直径标线
      makerjs.model.addCaption(myRlhHolesMarkGRightdn, TxtD, [0,0], [d+markHolesOneD, -d-markHolesOneD]);//直径文字标注
      /*****************************************************************************/     
      makerjs.model.addPath(myRlhHolesYMarkGRightdn, new makerjs.paths.Line([-w,-y0-markShiftTwo], [0,-y0-markShiftTwo]));//Y短标线
      makerjs.model.addCaption(myRlhHolesYMarkGRightdn, TxtW, [-w,-y0-markShiftFour], [0,-y0-markShiftFour]);//Y文字标注
      /*****************************************************************************/ 
      plate.models["TypeHoles_RotatLockHole_GRightup"+myHolesNum]=myRlhHolesGRightup;
      cutPlate.models["TypeHoles_RotatLockHole_GRightup"+myHolesNum]=myRlhHolesGRightup;
      markers.models["TypeHoles_RotatLockHole_GRightup"+myHolesNum]=myRlhHolesGRightup;
      markers.models["TypeHoles_RotatLockHole_MarkGRightup"+myHolesNum]=myRlhHolesMarkGRightup;
      markers.models["TypeHoles_RotatLockHole_XMarkGRightup"+myHolesNum]=myRlhHolesXMarkGRightup;
      markers.models["TypeHoles_RotatLockHole_YMarkGRightup"+myHolesNum]=myRlhHolesYMarkGRightup;
      /*****************************************************************************/
      plate.models["TypeHoles_RotatLockHole_GRightdn"+myHolesNum]=myRlhHolesGRightdn;
      cutPlate.models["TypeHoles_RotatLockHole_GRightdn"+myHolesNum]=myRlhHolesGRightdn;
      markers.models["TypeHoles_RotatLockHole_GRightdn"+myHolesNum]=myRlhHolesGRightdn;
      markers.models["TypeHoles_RotatLockHole_MarkGRightdn"+myHolesNum]=myRlhHolesMarkGRightdn;
      markers.models["TypeHoles_RotatLockHole_YMarkGRightdn"+myHolesNum]=myRlhHolesYMarkGRightdn;
      /*****************************************************************************/ 
      plate.models["TypeHoles_RotatLockHole_GLeftup"+myHolesNum]=myRlhHolesGLeftup;
      cutPlate.models["TypeHoles_RotatLockHole_GLeftup"+myHolesNum]=myRlhHolesGLeftup;
      markers.models["TypeHoles_RotatLockHole_GLeftup"+myHolesNum]=myRlhHolesGLeftup;
      markers.models["TypeHoles_RotatLockHole_MarkGLeftup"+myHolesNum]=myRlhHolesMarkGLeftup;
      markers.models["TypeHoles_RotatLockHole_XMarkGLeftup"+myHolesNum]=myRlhHolesXMarkGLeftup;
      /*****************************************************************************/ 
         
      } else if(area==8){
        //画孔 H位置孔
            //标记旋转锁孔 H位置孔右上
            var myRlhHolesHRightup= new makerjs.models.Holes(d/2, [[xh-w/2, yh]]);
            //标记孔
            var myRlhHolesMarkHRightup = new makerjs.models.Square(0); //孔的原点       
            myRlhHolesMarkHRightup.origin = [xh-w/2, yh];      
            var myRlhHolesXMarkHRightup = new makerjs.models.Square(0);      
            myRlhHolesXMarkHRightup.origin =[xh-w/2, yh];      
            var myRlhHolesYMarkHRightup = new makerjs.models.Square(0);      
            myRlhHolesYMarkHRightup.origin = [xh-w/2, yh];  
      /*****************************************************************************/ 
    
      makerjs.model.addPath(myRlhHolesMarkHRightup, new makerjs.paths.Line([xh,0], [xh+w/2+markShiftFour, 0]));//Y轴加长标线
      makerjs.model.addPath(myRlhHolesMarkHRightup, new makerjs.paths.Line([0,-y0], [xh+w/2+markShiftFour, -y0]));//X轴加长标线
      makerjs.model.addPath(myRlhHolesMarkHRightup, new makerjs.paths.Line([0,0], [0, -y0]));//从孔圆心出发Y方向竖向标线
    
    
      makerjs.model.addPath(myRlhHolesMarkHRightup, new makerjs.paths.Line([xh,0], [xh+w/2+markShiftFour, 0]));//Y轴加长标线
      makerjs.model.addPath(myRlhHolesMarkHRightup, new makerjs.paths.Line([0,-y0], [xh+w/2+markShiftFour, -y0]));//从孔圆心出发X方向横向标线
      makerjs.model.addPath(myRlhHolesMarkHRightup, new makerjs.paths.Line([0,0], [0, -y0]));//从孔圆心出发Y方向竖向标线
      /*****************************************************************************/ 
      makerjs.model.addPath(myRlhHolesMarkHRightup, new makerjs.paths.Line([0,0], [d, -d]));//直径标线
      makerjs.model.addCaption(myRlhHolesMarkHRightup, TxtD, [0,0], [d+markHolesOneD, -d-markHolesOneD]);//直径文字标注
      /*****************************************************************************/    
      makerjs.model.addPath(myRlhHolesYMarkHRightup, new makerjs.paths.Line([xh+w/2+markShift,0], [xh+w/2+markShift, -y0]));//Y短标线
      makerjs.model.addCaption(myRlhHolesYMarkHRightup, TxtY, [xh+w/2+markShiftThree,-y0], [xh+w/2+markShiftThree, 0]);//Y文字标注
      /*****************************************************************************/ 
      //画孔 H位置孔
            //标记旋转锁孔 H位置孔左上
            var myRlhHolesHLeftup= new makerjs.models.Holes(d/2, [[xh+w/2, yh]]);
            var myRlhHolesMarkHLeftup = new makerjs.models.Square(0); //孔的原点       
            myRlhHolesMarkHLeftup.origin = [xh+w/2, yh];      
            var myRlhHolesXMarkHLeftup = new makerjs.models.Square(0);      
            myRlhHolesXMarkHLeftup.origin =[xh+w/2, yh]; 
      /*****************************************************************************/ 
      makerjs.model.addPath(myRlhHolesMarkHLeftup, new makerjs.paths.Line([0,0], [-w, 0]));//从孔圆心出发X方向横向标线
      makerjs.model.addPath(myRlhHolesMarkHLeftup, new makerjs.paths.Line([0,0], [xb-w+markShiftFour,0]));//从孔圆心出发Y方向竖向标线
      /*****************************************************************************/ 
      makerjs.model.addPath(myRlhHolesXMarkHLeftup, new makerjs.paths.Line([-w,0], [0, 0]));//X短标线
      makerjs.model.addCaption(myRlhHolesXMarkHLeftup, TxtW, [-w,0+markShift], [0, 0+markShift]);//X文字标注
      /*****************************************************************************/ 
       //标记旋转锁孔 H位置孔右下
       var myRlhHolesHRightdn= new makerjs.models.Holes(d/2, [[xh-w/2, yh+h]]);
            var myRlhHolesMarkHRightdn = new makerjs.models.Square(0); //孔的原点       
            myRlhHolesMarkHRightdn.origin = [xh-w/2, yh+h];   
            var myRlhHolesYMarkHRightdn = new makerjs.models.Square(0);      
            myRlhHolesYMarkHRightdn.origin = [xh-w/2, yh+h]; 
      /*****************************************************************************/ 
      makerjs.model.addPath(myRlhHolesMarkHRightdn, new makerjs.paths.Line([0,0], [xb+w/2+markShiftThree, 0]));//从孔圆心出发X方向横向标线
      makerjs.model.addPath(myRlhHolesMarkHRightdn, new makerjs.paths.Line([0,0], [0, -h]));//从孔圆心出发Y方向竖向标线
      /*****************************************************************************/ 
      makerjs.model.addPath(myRlhHolesYMarkHRightdn, new makerjs.paths.Line([xb+w/2+markShift, -h],[xb+w/2+markShift,0]));//Y短标线
      makerjs.model.addCaption(myRlhHolesYMarkHRightdn, TxtH, [xb+w/2+markShiftThree,-h], [xb+w/2+markShiftThree, 0]);//Y文字标注
      /*****************************************************************************/ 
      /*****************************************************************************/ 
      plate.models["TypeHoles_RotatLockHole_HRightup"+myHolesNum]=myRlhHolesHRightup;
      cutPlate.models["TypeHoles_RotatLockHole_HRightup"+myHolesNum]=myRlhHolesHRightup;
      markers.models["TypeHoles_RotatLockHole_HRightup"+myHolesNum]=myRlhHolesHRightup;
      markers.models["TypeHoles_RotatLockHole_MarkHRightup"+myHolesNum]=myRlhHolesMarkHRightup;
      markers.models["TypeHoles_RotatLockHole_XMarkHRightup"+myHolesNum]=myRlhHolesXMarkHRightup;
      markers.models["TypeHoles_RotatLockHole_YMarkHRightup"+myHolesNum]=myRlhHolesYMarkHRightup;
      /*****************************************************************************/
      plate.models["TypeHoles_RotatLockHole_HRightdn"+myHolesNum]=myRlhHolesHRightdn;
      cutPlate.models["TypeHoles_RotatLockHole_HRightdn"+myHolesNum]=myRlhHolesHRightdn;
      markers.models["TypeHoles_RotatLockHole_HRightdn"+myHolesNum]=myRlhHolesHRightdn;
      markers.models["TypeHoles_RotatLockHole_MarkHRightdn"+myHolesNum]=myRlhHolesMarkHRightdn;
      markers.models["TypeHoles_RotatLockHole_YMarkHRightdn"+myHolesNum]=myRlhHolesYMarkHRightdn;
      /*****************************************************************************/ 
      plate.models["TypeHoles_RotatLockHole_HLeftup"+myHolesNum]=myRlhHolesHLeftup;
      cutPlate.models["TypeHoles_RotatLockHole_HLeftup"+myHolesNum]=myRlhHolesHLeftup;
      markers.models["TypeHoles_RotatLockHole_HLeftup"+myHolesNum]=myRlhHolesHLeftup;
      markers.models["TypeHoles_RotatLockHole_MarkHLeftup"+myHolesNum]=myRlhHolesMarkHLeftup;
      markers.models["TypeHoles_RotatLockHole_XMarkHLeftup"+myHolesNum]=myRlhHolesXMarkHLeftup;
      /*****************************************************************************/ 
          
      }

 }else{
      console.log("短边在X轴￥￥￥￥￥"); 
      if(area==1){
            //画孔 A位置孔
                //标记旋转锁孔 A位置孔左上
                var myRlhHolesALeftup= new makerjs.models.Holes(d/2, [[xa, ya]]);
                //标记孔
                var myRlhHolesMarkALeftup = new makerjs.models.Square(0); //孔的原点       
                myRlhHolesMarkALeftup.origin = [xa, ya];      
                var myRlhHolesXMarkALeftup = new makerjs.models.Square(0);      
                myRlhHolesXMarkALeftup.origin =[xa, ya];      
                var myRlhHolesYMarkALeftup = new makerjs.models.Square(0);      
                myRlhHolesYMarkALeftup.origin = [xa, ya];  
          
          /*****************************************************************************/ 
          makerjs.model.addPath(myRlhHolesMarkALeftup, new makerjs.paths.Line([-x0,y0], [-x0, y0+markShiftTwo]));//Y轴加长标线
          makerjs.model.addPath(myRlhHolesMarkALeftup, new makerjs.paths.Line([0,0], [-x0-markShiftThree, 0]));//从孔圆心出发X方向横向标线
          makerjs.model.addPath(myRlhHolesMarkALeftup, new makerjs.paths.Line([-x0,y0], [-x0-markShiftThree, y0]));//X轴加长标线
          makerjs.model.addPath(myRlhHolesMarkALeftup, new makerjs.paths.Line([0,0], [0, y0+markShiftTwo]));//从孔圆心出发Y方向竖向标线
          /*****************************************************************************/ 
          makerjs.model.addPath(myRlhHolesMarkALeftup, new makerjs.paths.Line([0,0], [d, -d]));//直径标线
          makerjs.model.addCaption(myRlhHolesMarkALeftup, TxtD, [0,0], [d+markHolesOneD, -d-markHolesOneD]);//直径文字标注
          /*****************************************************************************/   
          makerjs.model.addPath(myRlhHolesXMarkALeftup, new makerjs.paths.Line([0,y0+markShift], [-x0, y0+markShift]));//X短标线
          makerjs.model.addCaption(myRlhHolesXMarkALeftup, TxtX, [-x0,y0+markShiftTwo], [0, y0+markShiftTwo]);//X文字标注
          /*****************************************************************************/     
          makerjs.model.addPath(myRlhHolesYMarkALeftup, new makerjs.paths.Line([-x0-markShiftTwo,0], [-x0-markShiftTwo, y0]));//Y短标线
          makerjs.model.addCaption(myRlhHolesYMarkALeftup, TxtY, [-x0-markShiftThree,0], [-x0-markShiftThree, y0]);//Y文字标注
          /*****************************************************************************/ 
          /*****************************************************************************/ 
          //画孔 A位置孔
                //标记旋转锁孔 A位置孔右上
                var myRlhHolesARightup= new makerjs.models.Holes(d/2, [[xa+w, ya]]);
                var myRlhHolesMarkARightup = new makerjs.models.Square(0); //孔的原点       
                myRlhHolesMarkARightup.origin = [xa+w, ya];      
                var myRlhHolesXMarkARightup = new makerjs.models.Square(0);      
                myRlhHolesXMarkARightup.origin =[xa+w, ya]; 
          /*****************************************************************************/ 
          makerjs.model.addPath(myRlhHolesMarkARightup, new makerjs.paths.Line([0,0], [-w, 0]));//从孔圆心出发X方向横向标线
          makerjs.model.addPath(myRlhHolesMarkARightup, new makerjs.paths.Line([0,0], [0, y0+markShiftTwo]));//从孔圆心出发Y方向竖向标线
          /*****************************************************************************/ 
          makerjs.model.addPath(myRlhHolesMarkARightup, new makerjs.paths.Line([0,0], [d, -d]));//直径标线
          makerjs.model.addCaption(myRlhHolesMarkARightup, TxtD, [0,0], [d+markHolesOneD, -d-markHolesOneD]);//直径文字标注
          /*****************************************************************************/   
          makerjs.model.addPath(myRlhHolesXMarkARightup, new makerjs.paths.Line([0,y0+markShift], [-w, y0+markShift]));//X短标线
          makerjs.model.addCaption(myRlhHolesXMarkARightup, TxtW, [-w,y0+markShiftTwo], [0, y0+markShiftTwo]);//X文字标注
          /*****************************************************************************/  
          /*****************************************************************************/ 
           //标记旋转锁孔 A位置孔左下
           var myRlhHolesALeftdn= new makerjs.models.Holes(d/2, [[xa, ya-h]]);
                var myRlhHolesMarkALeftdn = new makerjs.models.Square(0); //孔的原点       
                myRlhHolesMarkALeftdn.origin = [xa, ya-h];   
                var myRlhHolesYMarkALeftdn = new makerjs.models.Square(0);      
                myRlhHolesYMarkALeftdn.origin = [xa, ya-h]; 
          /*****************************************************************************/ 
          makerjs.model.addPath(myRlhHolesMarkALeftdn, new makerjs.paths.Line([0,0], [-x0-markShiftThree, 0]));//从孔圆心出发X方向横向标线
          makerjs.model.addPath(myRlhHolesMarkALeftdn, new makerjs.paths.Line([0,0], [0, h+markShiftTwo]));//从孔圆心出发Y方向竖向标线
          /*****************************************************************************/ 
          makerjs.model.addPath(myRlhHolesMarkALeftdn, new makerjs.paths.Line([0,0], [d, -d]));//直径标线
          makerjs.model.addCaption(myRlhHolesMarkALeftdn, TxtD, [0,0], [d+markHolesOneD, -d-markHolesOneD]);//直径文字标注
          /*****************************************************************************/  
          /*****************************************************************************/     
          makerjs.model.addPath(myRlhHolesYMarkALeftdn, new makerjs.paths.Line([-x0-markShiftTwo,0], [-x0-markShiftTwo, h]));//Y短标线
          makerjs.model.addCaption(myRlhHolesYMarkALeftdn, TxtH, [-x0-markShiftThree,0], [-x0-markShiftThree, h]);//Y文字标注
          /*****************************************************************************/ 
          plate.models["TypeHoles_RotatLockHole_ALeftup"+myHolesNum]=myRlhHolesALeftup;
          cutPlate.models["TypeHoles_RotatLockHole_ALeftup"+myHolesNum]=myRlhHolesALeftup;
          markers.models["TypeHoles_RotatLockHole_ALeftup"+myHolesNum]=myRlhHolesALeftup;
          markers.models["TypeHoles_RotatLockHole_MarkALeftup"+myHolesNum]=myRlhHolesMarkALeftup;
          markers.models["TypeHoles_RotatLockHole_XMarkALeftup"+myHolesNum]=myRlhHolesXMarkALeftup;
          markers.models["TypeHoles_RotatLockHole_YMarkALeftup"+myHolesNum]=myRlhHolesYMarkALeftup;
          /*****************************************************************************/
          plate.models["TypeHoles_RotatLockHole_ALeftdn"+myHolesNum]=myRlhHolesALeftdn;
          cutPlate.models["TypeHoles_RotatLockHole_ALeftdn"+myHolesNum]=myRlhHolesALeftdn;
          markers.models["TypeHoles_RotatLockHole_ALeftdn"+myHolesNum]=myRlhHolesALeftdn;
          markers.models["TypeHoles_RotatLockHole_MarkALeftdn"+myHolesNum]=myRlhHolesMarkALeftdn;
          markers.models["TypeHoles_RotatLockHole_YMarkALeftdn"+myHolesNum]=myRlhHolesYMarkALeftdn;
          /*****************************************************************************/ 
          plate.models["TypeHoles_RotatLockHole_ARightup"+myHolesNum]=myRlhHolesARightup;
          cutPlate.models["TypeHoles_RotatLockHole_ARightup"+myHolesNum]=myRlhHolesARightup;
          markers.models["TypeHoles_RotatLockHole_ARightup"+myHolesNum]=myRlhHolesARightup;
          markers.models["TypeHoles_RotatLockHole_MarkARightup"+myHolesNum]=myRlhHolesMarkARightup;
          markers.models["TypeHoles_RotatLockHole_XMarkARightup"+myHolesNum]=myRlhHolesXMarkARightup;
          /*****************************************************************************/ 
          
      } else if(area==4){
           //画孔 D位置孔
                //标记旋转锁孔 D位置孔左上
                var myRlhHolesDLeftup= new makerjs.models.Holes(d/2, [[xd, yd+h/2]]);
                //标记孔
                var myRlhHolesMarkDLeftup = new makerjs.models.Square(0); //孔的原点       
                myRlhHolesMarkDLeftup.origin = [xd, yd+h/2];      
                var myRlhHolesXMarkDLeftup = new makerjs.models.Square(0);      
                myRlhHolesXMarkDLeftup.origin =[xd, yd+h/2];      
                var myRlhHolesYMarkDLeftup = new makerjs.models.Square(0);      
                myRlhHolesYMarkDLeftup.origin = [xd, yd+h/2];  
          makerjs.model.addPath(myRlhHolesMarkDLeftup, new makerjs.paths.Line([0,0], [d, -d]));//直径标线
          makerjs.model.addCaption(myRlhHolesMarkDLeftup, TxtD, [0,0], [d+markHolesOneD, -d-markHolesOneD]);//直径文字标注
          /*****************************************************************************/    
          makerjs.model.addPath(myRlhHolesYMarkDLeftup, new makerjs.paths.Line([-x0,0], [0, 0]));//Y短标线
          makerjs.model.addCaption(myRlhHolesYMarkDLeftup, TxtX, [-x0,markShift], [0, markShift]);//Y文字标注
          /*****************************************************************************/ 
          //画孔 D位置孔
                //标记旋转锁孔 D位置孔右上
                var myRlhHolesDRightup= new makerjs.models.Holes(d/2, [[xd+w, yd+h/2]]);
                var myRlhHolesMarkDRightup = new makerjs.models.Square(0); //孔的原点       
                myRlhHolesMarkDRightup.origin = [xd+w, yd+h/2];      
                var myRlhHolesXMarkDRightup = new makerjs.models.Square(0);      
                myRlhHolesXMarkDRightup.origin =[xd+w, yd+h/2]; 
          /*****************************************************************************/ 
          makerjs.model.addPath(myRlhHolesXMarkDRightup, new makerjs.paths.Line([0,0], [-w, 0]));//X短标线
          makerjs.model.addCaption(myRlhHolesXMarkDRightup, TxtW, [-w,0+markShift], [0, 0+markShift]);//X文字标注
          /*****************************************************************************/ 
           //标记旋转锁孔 D位置孔左下
           var myRlhHolesDLeftdn= new makerjs.models.Holes(d/2, [[xd, yd-h/2]]);
                var myRlhHolesMarkDLeftdn = new makerjs.models.Square(0); //孔的原点       
                myRlhHolesMarkDLeftdn.origin = [xd, yd-h/2];   
                var myRlhHolesYMarkDLeftdn = new makerjs.models.Square(0);      
                myRlhHolesYMarkDLeftdn.origin = [xd, yd-h/2]; 
          /*****************************************************************************/ 
          makerjs.model.addPath(myRlhHolesMarkDLeftdn, new makerjs.paths.Line([0,0], [0, h]));//从孔圆心出发Y方向竖向标线
          /*****************************************************************************/ 
          makerjs.model.addCaption(myRlhHolesYMarkDLeftdn, TxtH, [-markShift,0], [-markShift, h]);//Y文字标注
          /*****************************************************************************/ 
          plate.models["TypeHoles_RotatLockHole_DLeftup"+myHolesNum]=myRlhHolesDLeftup;
          cutPlate.models["TypeHoles_RotatLockHole_DLeftup"+myHolesNum]=myRlhHolesDLeftup;
          markers.models["TypeHoles_RotatLockHole_DLeftup"+myHolesNum]=myRlhHolesDLeftup;
          markers.models["TypeHoles_RotatLockHole_MarkDLeftup"+myHolesNum]=myRlhHolesMarkDLeftup;
          markers.models["TypeHoles_RotatLockHole_XMarkDLeftup"+myHolesNum]=myRlhHolesXMarkDLeftup;
          markers.models["TypeHoles_RotatLockHole_YMarkDLeftup"+myHolesNum]=myRlhHolesYMarkDLeftup;
          /*****************************************************************************/
          plate.models["TypeHoles_RotatLockHole_DLeftdn"+myHolesNum]=myRlhHolesDLeftdn;
          cutPlate.models["TypeHoles_RotatLockHole_DLeftdn"+myHolesNum]=myRlhHolesDLeftdn;
          markers.models["TypeHoles_RotatLockHole_DLeftdn"+myHolesNum]=myRlhHolesDLeftdn;
          markers.models["TypeHoles_RotatLockHole_MarkDLeftdn"+myHolesNum]=myRlhHolesMarkDLeftdn;
          markers.models["TypeHoles_RotatLockHole_YMarkDLeftdn"+myHolesNum]=myRlhHolesYMarkDLeftdn;
          /*****************************************************************************/ 
          plate.models["TypeHoles_RotatLockHole_DRightup"+myHolesNum]=myRlhHolesDRightup;
          cutPlate.models["TypeHoles_RotatLockHole_DRightup"+myHolesNum]=myRlhHolesDRightup;
          markers.models["TypeHoles_RotatLockHole_DRightup"+myHolesNum]=myRlhHolesDRightup;
          markers.models["TypeHoles_RotatLockHole_MarkDRightup"+myHolesNum]=myRlhHolesMarkDRightup;
          markers.models["TypeHoles_RotatLockHole_XMarkDRightup"+myHolesNum]=myRlhHolesXMarkDRightup;
          /*****************************************************************************/ 
             
      } else if(area==3){
          //画孔 C位置孔
                //标记旋转锁孔 C位置孔右上
                var myRlhHolesCRightup= new makerjs.models.Holes(d/2, [[xc, yc]]);
                //标记孔
                var myRlhHolesMarkCRightup = new makerjs.models.Square(0); //孔的原点       
                myRlhHolesMarkCRightup.origin = [xc, yc];      
                var myRlhHolesXMarkCRightup = new makerjs.models.Square(0);      
                myRlhHolesXMarkCRightup.origin =[xc, yc];      
                var myRlhHolesYMarkCRightup = new makerjs.models.Square(0);      
                myRlhHolesYMarkCRightup.origin = [xc, yc];  
          /*****************************************************************************/ 
          makerjs.model.addPath(myRlhHolesMarkCRightup, new makerjs.paths.Line([x0,y0], [x0, y0+markShiftFour]));//Y轴加长标线
          makerjs.model.addPath(myRlhHolesMarkCRightup, new makerjs.paths.Line([0,0], [x0+markShiftThree, 0]));//从孔圆心出发X方向横向标线
          makerjs.model.addPath(myRlhHolesMarkCRightup, new makerjs.paths.Line([x0,y0], [x0+markShiftThree, y0]));//X轴加长标线
          makerjs.model.addPath(myRlhHolesMarkCRightup, new makerjs.paths.Line([0,0], [0, y0+markShiftFour]));//从孔圆心出发Y方向竖向标线
          /*****************************************************************************/ 
          makerjs.model.addPath(myRlhHolesMarkCRightup, new makerjs.paths.Line([0,0], [d, -d]));//直径标线
          makerjs.model.addCaption(myRlhHolesMarkCRightup, TxtD, [0,0], [d+markHolesOneD, -d-markHolesOneD]);//直径文字标注
          /*****************************************************************************/   
          makerjs.model.addPath(myRlhHolesXMarkCRightup, new makerjs.paths.Line([0,y0+markShiftTwo], [x0, y0+markShiftTwo]));//X短标线
          makerjs.model.addCaption(myRlhHolesXMarkCRightup, TxtX, [0,y0+markShiftFour], [x0, y0+markShiftFour]);//X文字标注
          /*****************************************************************************/     
          makerjs.model.addPath(myRlhHolesYMarkCRightup, new makerjs.paths.Line([x0+markShiftTwo,0], [x0+markShiftTwo, y0]));//Y短标线
          makerjs.model.addCaption(myRlhHolesYMarkCRightup, TxtY, [x0+markShiftFour, 0], [x0+markShiftFour,y0]);//Y文字标注
          /*****************************************************************************/ 
          //画孔 C位置孔
                //标记旋转锁孔 C位置孔左上
                var myRlhHolesCLeftup= new makerjs.models.Holes(d/2, [[xc, yc-h]]);
                var myRlhHolesMarkCLeftup = new makerjs.models.Square(0); //孔的原点       
                myRlhHolesMarkCLeftup.origin = [xc, yc-h];      
                var myRlhHolesXMarkCLeftup = new makerjs.models.Square(0);      
                myRlhHolesXMarkCLeftup.origin =[xc, yc-h]; 
          /*****************************************************************************/ 
          makerjs.model.addPath(myRlhHolesMarkCLeftup, new makerjs.paths.Line([0,0], [0, h]));//从孔圆心出发X方向横向标线
          makerjs.model.addCaption(myRlhHolesXMarkCLeftup, TxtH,[-markShift,0], [-markShift, h]);//X文字标注
          /*****************************************************************************/ 
           //标记旋转锁孔 C位置孔右下
           var myRlhHolesCRightdn= new makerjs.models.Holes(d/2, [[xc-w, yc]]);
                var myRlhHolesMarkCRightdn = new makerjs.models.Square(0); //孔的原点       
                myRlhHolesMarkCRightdn.origin = [xc-w, yc];   
                var myRlhHolesYMarkCRightdn = new makerjs.models.Square(0);      
                myRlhHolesYMarkCRightdn.origin = [xc-w, yc]; 
          /*****************************************************************************/
          makerjs.model.addPath(myRlhHolesYMarkCRightdn, new makerjs.paths.Line([0,0], [w,0]));//Y短标线
          makerjs.model.addCaption(myRlhHolesYMarkCRightdn, TxtW, [0,markShift], [w,markShift]);//Y文字标注
          /*****************************************************************************/ 
          plate.models["TypeHoles_RotatLockHole_CRightup"+myHolesNum]=myRlhHolesCRightup;
          cutPlate.models["TypeHoles_RotatLockHole_CRightup"+myHolesNum]=myRlhHolesCRightup;
          markers.models["TypeHoles_RotatLockHole_CRightup"+myHolesNum]=myRlhHolesCRightup;
          markers.models["TypeHoles_RotatLockHole_MarkCRightup"+myHolesNum]=myRlhHolesMarkCRightup;
          markers.models["TypeHoles_RotatLockHole_XMarkCRightup"+myHolesNum]=myRlhHolesXMarkCRightup;
          markers.models["TypeHoles_RotatLockHole_YMarkCRightup"+myHolesNum]=myRlhHolesYMarkCRightup;
          /*****************************************************************************/
          plate.models["TypeHoles_RotatLockHole_CRightdn"+myHolesNum]=myRlhHolesCRightdn;
          cutPlate.models["TypeHoles_RotatLockHole_CRightdn"+myHolesNum]=myRlhHolesCRightdn;
          markers.models["TypeHoles_RotatLockHole_CRightdn"+myHolesNum]=myRlhHolesCRightdn;
          markers.models["TypeHoles_RotatLockHole_MarkCRightdn"+myHolesNum]=myRlhHolesMarkCRightdn;
          markers.models["TypeHoles_RotatLockHole_YMarkCRightdn"+myHolesNum]=myRlhHolesYMarkCRightdn;
          /*****************************************************************************/ 
          plate.models["TypeHoles_RotatLockHole_CLeftup"+myHolesNum]=myRlhHolesCLeftup;
          cutPlate.models["TypeHoles_RotatLockHole_CLeftup"+myHolesNum]=myRlhHolesCLeftup;
          markers.models["TypeHoles_RotatLockHole_CLeftup"+myHolesNum]=myRlhHolesCLeftup;
          markers.models["TypeHoles_RotatLockHole_MarkCLeftup"+myHolesNum]=myRlhHolesMarkCLeftup;
          markers.models["TypeHoles_RotatLockHole_XMarkCLeftup"+myHolesNum]=myRlhHolesXMarkCLeftup;
          /*****************************************************************************/ 
             
      } else if(area==6){
            //画孔 F位置孔
                //标记旋转锁孔 F位置孔右上
                var myRlhHolesFRightup= new makerjs.models.Holes(d/2, [[xf, yf+h/2]]);
                //标记孔
                var myRlhHolesMarkFRightup = new makerjs.models.Square(0); //孔的原点       
                myRlhHolesMarkFRightup.origin = [xf, yf+h/2];      
                var myRlhHolesXMarkFRightup = new makerjs.models.Square(0);      
                myRlhHolesXMarkFRightup.origin =[xf, yf+h/2];      
                var myRlhHolesYMarkFRightup = new makerjs.models.Square(0);      
                myRlhHolesYMarkFRightup.origin = [xf, yf+h/2];  
          /*****************************************************************************/ 
          makerjs.model.addPath(myRlhHolesMarkFRightup, new makerjs.paths.Line([0,0], [d, -d]));//直径标线
          makerjs.model.addCaption(myRlhHolesMarkFRightup, TxtD, [0,0], [d+markHolesOneD, -d-markHolesOneD]);//直径文字标注
          /*****************************************************************************/    
          makerjs.model.addPath(myRlhHolesYMarkFRightup, new makerjs.paths.Line([0,0], [x0, 0]));//Y短标线
          makerjs.model.addCaption(myRlhHolesYMarkFRightup, TxtX, [0,markShift], [x0,markShift]);//Y文字标注
          /*****************************************************************************/ 
          //画孔 F位置孔
                //标记旋转锁孔 F位置孔左上
                var myRlhHolesFLeftup= new makerjs.models.Holes(d/2, [[xf-w, yf+h/2]]);
                var myRlhHolesMarkFLeftup = new makerjs.models.Square(0); //孔的原点       
                myRlhHolesMarkFLeftup.origin = [xf-w, yf+h/2];      
                var myRlhHolesXMarkFLeftup = new makerjs.models.Square(0);      
                myRlhHolesXMarkFLeftup.origin =[xf-w, yf+h/2]; 
          /*****************************************************************************/ 
          makerjs.model.addPath(myRlhHolesXMarkFLeftup, new makerjs.paths.Line([0,0], [w, 0]));//X短标线
          makerjs.model.addCaption(myRlhHolesXMarkFLeftup, TxtW, [0,0+markShift], [w, 0+markShift]);//X文字标注
          /*****************************************************************************/ 
           //标记旋转锁孔 F位置孔右下
           var myRlhHolesFRightdn= new makerjs.models.Holes(d/2, [[xf, yf-h/2]]);
                var myRlhHolesMarkFRightdn = new makerjs.models.Square(0); //孔的原点       
                myRlhHolesMarkFRightdn.origin = [xf, yf-h/2];   
                var myRlhHolesYMarkFRightdn = new makerjs.models.Square(0);      
                myRlhHolesYMarkFRightdn.origin = [xf, yf-h/2]; 
          /*****************************************************************************/ 
          makerjs.model.addPath(myRlhHolesYMarkFRightdn, new makerjs.paths.Line([0, 0],[0,h]));//Y短标线
          makerjs.model.addCaption(myRlhHolesYMarkFRightdn, TxtH, [-markShift, 0],[-markShift,h]);//Y文字标注
          /*****************************************************************************/ 
          plate.models["TypeHoles_RotatLockHole_FRightup"+myHolesNum]=myRlhHolesFRightup;
          cutPlate.models["TypeHoles_RotatLockHole_FRightup"+myHolesNum]=myRlhHolesFRightup;
          markers.models["TypeHoles_RotatLockHole_FRightup"+myHolesNum]=myRlhHolesFRightup;
          markers.models["TypeHoles_RotatLockHole_MarkFRightup"+myHolesNum]=myRlhHolesMarkFRightup;
          markers.models["TypeHoles_RotatLockHole_XMarkFRightup"+myHolesNum]=myRlhHolesXMarkFRightup;
          markers.models["TypeHoles_RotatLockHole_YMarkFRightup"+myHolesNum]=myRlhHolesYMarkFRightup;
          /*****************************************************************************/
          plate.models["TypeHoles_RotatLockHole_FRightdn"+myHolesNum]=myRlhHolesFRightdn;
          cutPlate.models["TypeHoles_RotatLockHole_FRightdn"+myHolesNum]=myRlhHolesFRightdn;
          markers.models["TypeHoles_RotatLockHole_FRightdn"+myHolesNum]=myRlhHolesFRightdn;
          markers.models["TypeHoles_RotatLockHole_MarkFRightdn"+myHolesNum]=myRlhHolesMarkFRightdn;
          markers.models["TypeHoles_RotatLockHole_YMarkFRightdn"+myHolesNum]=myRlhHolesYMarkFRightdn;
          /*****************************************************************************/ 
          plate.models["TypeHoles_RotatLockHole_FLeftup"+myHolesNum]=myRlhHolesFLeftup;
          cutPlate.models["TypeHoles_RotatLockHole_FLeftup"+myHolesNum]=myRlhHolesFLeftup;
          markers.models["TypeHoles_RotatLockHole_FLeftup"+myHolesNum]=myRlhHolesFLeftup;
          markers.models["TypeHoles_RotatLockHole_MarkFLeftup"+myHolesNum]=myRlhHolesMarkFLeftup;
          markers.models["TypeHoles_RotatLockHole_XMarkFLeftup"+myHolesNum]=myRlhHolesXMarkFLeftup;
          /*****************************************************************************/ 
              
      }
  }

myHolesNum++;
return{plate,cutPlate, markers,myHolesNum}
};


export default RotatLockHole;